// Importing the axios library for making HTTP requests
import axios from "axios";

// Importing a helper function to retrieve the WorkWise authentication token
import { formatFileSize, getWorkWiseAuthToken } from "./utils/helper";

// Defining server URLs for different APIs
export const serverUrl = "http://localhost:3100/padApi/v2"; // Local server URL
export const baseURL = 'https://board.workw.com/api/';
export const workwiseUrl = "https://workw.com/workwapi/api"; // WorkWise API URL
export const localWorkwUrl = 'https://58.65.211.234:4436/konnectapi/api'; // Local WorkWise API URL  

// export const workwiseUrl = "https://58.65.211.234:4436/Konnectapi"; // Alternative WorkWise API URL
// export const serverUrl = "https://pad.workw.com"; // Alternative server URL

// Creating headers with WorkWise authentication token
const workwiseHeaders = { 'Authorization': `Bearer ${getWorkWiseAuthToken()}` };
let debounceTimeout;

export const boardServices = {

  loadBoardData: async (id) => {
    try {
      // document.getElementById("mileboard-name").innerHTML = mileboardName;
      return await axios.get(
        `${baseURL}boards/${id}`
      );
      // console.log(response.data[0].mileboardData[0])
    } catch (error) {
      console.log(error);
    }
  },
  getBoardData: async (id) => {
    try {
      const response = await axios.get(`${baseURL}boards/${id}`);
      return response?.data?.[0] || null;
    } catch (error) {
      console.error('Error fetching board data:', error);
      return null;
    }
  },
  updateBoardData: async (id, data, setSavingData) => {
    try {
      // Make the API call to update the board data
      await axios.post(
        `${baseURL}boards/update`,
        {
          mileboardID: id,
          mileboardData: data,
        }
      );

      // Optional: Save the last update using another service
      workwiseServices.saveDocumentlastUpdate(id, setSavingData, data);
    } catch (error) {
      console.error("Error updating board data:", error);
    }
  },
  createTemplate: async (payload) => {
    try {
      await axios.post(`${baseURL}template`, payload);
    } catch (e) {
      console.error(e, 'error while creating template.');
    }
  },
  getAllTemplates: async () => {
    try {
      return await axios.get(`${baseURL}template`);
    } catch (e) {
      console.error(e, 'error while creating template.');
    }
  },
  verifyExternal: async (id) => {
    const response = await axios.get(`${baseURL}external/verify/${id}`);
    return response.data;
  },
  updateDocumentPrivacy: async (data) => {
    const response = await axios.post(`${baseURL}external/privacyUpdate`, data);
    return response.data;
  },
};

// Exporting a collection of WorkWise-related services
export const workwiseServices = {
  /**
   * Retrieves a document by its ID from the WorkWise API.
   *
   * @param {string} id - The ID of the document to retrieve.
   * @returns {Promise} A Promise that resolves with the response data.
   */
  async getDocumentById(id) {

    // Todo : To be Used When Live is Down

    // ! const dummyResponse = {
    // !  status: 200,
    // !  data: {
    // !    data: {
    // !      rightType: 2,
    // !      members: [],
    // !      name: "Dummy",
    // !      creator: {
    // !        id: "dss",
    // !        name: "YUP",
    // !        image: "tt"
    // !      },
    // !      createBy: "dsds"
    // !    }
    // !  }
    // !}
    // ! return dummyResponse;
    return axios.get(
      `${workwiseUrl}/Authorize/Authorize?id=${id}`,
      { headers: workwiseHeaders }
    );
  },
  async getAllSuggestion(payload) {
    return axios.post(
      `${workwiseUrl}/Suggestion/GetAllSuggestion`,
      payload,
      { headers: workwiseHeaders });
  },
  async addDocumentMember(id, payload) {
    return axios.post(
      `${workwiseUrl}/Document/AddDocumentMember?id=${id}`,
      payload,
      { headers: workwiseHeaders });
  },
  async shareDocumentToAnyone(payload) {
    return axios.post(`${workwiseUrl}/Document/UpdateDocument`,
      payload,
      { headers: workwiseHeaders }
    )
  },
  async saveDocumentlastUpdate(id, setSavingData, data) {
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleString();
    const size = new TextEncoder().encode(JSON.stringify(data)).length || 0;
    const sizeWithUnit = formatFileSize(size);

    if (setSavingData) {
      setSavingData({ isSaving: 'Saving...', lastSavedDateTime: '' });

      await new Promise(resolve => setTimeout(resolve, 600));

      setSavingData({
        isSaving: 'Saved',
        lastSavedDateTime: formattedDate,
        fileSize: sizeWithUnit
      });
    }

    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    debounceTimeout = setTimeout(async () => {
      try {
        await axios.post(`${workwiseUrl}/Document/SaveDocumentAttachment?attachmentId=${id}&fileSize=${size}`,
          {},
          { headers: workwiseHeaders }
        );
        // Handle the response if needed
      } catch (e) {
        console.error("error", e);
      }
    }, 5000);
  },
  async completeDocument(id) {
    try {
      const formData = new FormData();
      formData.append('id', id);

      await axios.post(`${workwiseUrl}/Document/CompleteDocument?id=${id}`,
        formData,
        { headers: workwiseHeaders }
      );
      // Handle the response if needed
    } catch (e) {
      console.error("error", e);
    }
  },
  async removeDocumentMember(data) {
    await axios.post(
      `${workwiseUrl}/Document/RemoveDocumentMember?id=${data.documentId}&status=${data.status}`,
      data.documentMembers,
      { headers: workwiseHeaders }
    );
  },
  async getAllDocumentList(payload) {
    return axios.post(
      `${workwiseUrl}/Document/GetAllDocumentList`,
      payload,
      { headers: workwiseHeaders });
  },
  async addDocument(formData) {
    return axios.post(
      `${workwiseUrl}/Document/AddDocument`,
      formData,
      { headers: workwiseHeaders });
  },
  async addDocumentDirectory(formData) {
    return axios.post(
      `${workwiseUrl}/Document/AddDocumentDirectory`,
      formData,
      { headers: workwiseHeaders });
  },
  async updateDocumentName(payload) {
    return axios.post(`${workwiseUrl}/Document/UpdateDocument`, payload, { headers: workwiseHeaders });
  },
};
